/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuizQuestionAnswerTemplateDto
 */
export interface QuizQuestionAnswerTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof QuizQuestionAnswerTemplateDto
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof QuizQuestionAnswerTemplateDto
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof QuizQuestionAnswerTemplateDto
     */
    displayText: string;
}

export function QuizQuestionAnswerTemplateDtoFromJSON(json: any): QuizQuestionAnswerTemplateDto {
    return {
        'number': json['number'],
        'text': json['text'],
        'displayText': json['displayText'],
    };
}

export function QuizQuestionAnswerTemplateDtoToJSON(value?: QuizQuestionAnswerTemplateDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'number': value.number,
        'text': value.text,
        'displayText': value.displayText,
    };
}


